import { createSelector } from 'reselect';

const selectAuthenticationData = (state) => state.get('data');

export const authenticationDataSelector = createSelector(selectAuthenticationData, (x) => x.toJS());
